import { render, staticRenderFns } from "./SendEmailInvoice.vue?vue&type=template&id=90e20f30&scoped=true"
import script from "./SendEmailInvoice.vue?vue&type=script&lang=js"
export * from "./SendEmailInvoice.vue?vue&type=script&lang=js"
import style0 from "./SendEmailInvoice.vue?vue&type=style&index=0&id=90e20f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e20f30",
  null
  
)

export default component.exports